<div class="shipment-identifier-table slds-grid slds-gutters slds-wrap">
  <form
    class="slds-col slds-size_1-of-1 slds-grid slds-gutters slds-wrap"
    [formGroup]="identifiersForm"
    (ngSubmit)="addIdentifier()"
  >
    <div [class]="field.className" *ngFor="let field of fields">
      <ng-container *ngIf="field.type === 'ups-input-with-helper'">
        <ngl-input
          [label]="field.templateOptions?.label || ''"
          [fieldLevelHelpTooltip]="field.templateOptions?.description || ''"
          [error]="getErrorMessages(identifiersForm?.get('shipmentIdentifierValue'))"
        >
          <input
            ngl
            [type]="type"
            [required]="field.templateOptions?.required || false"
            [placeholder]="field.templateOptions?.placeholder"
            [autocomplete]="field.templateOptions?.attributes?.['autocomplete'] || 'nope'"
            formControlName="{{ field.key }}"
          />
        </ngl-input>
      </ng-container>
      <ng-container *ngIf="field.type === 'ups-select'">
        <ngl-select [label]="field.templateOptions?.label || ''">
          <select ngl [required]="field.templateOptions?.required || false" formControlName="{{ field.key }}">
            <option *ngFor="let item of field.templateOptions?.options || $any([])" [value]="item.value">
              {{ item.label }}
            </option>
          </select>
        </ngl-select>
      </ng-container>
    </div>
    <div class="slds-col">
      <button class="add-btn" type="submit" nglButton variant="brand" [disabled]="!identifiersForm.valid">
        {{ 'createCase.addShipmentBtn' | translate }}
      </button>
    </div>
  </form>
  <div class="slds-col slds-size_9-of-12">
    <table [ngClass]="{ required: identifierRequired }">
      <thead>
        <th *ngFor="let header of tableHeaders">{{ header.label }}</th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngIf="!identifiers.length">
          <td colspan="3">{{ 'createCase.noIdentifiersMsg' | translate }}</td>
        </tr>
        <tr *ngFor="let item of model; let i = index">
          <td>{{ item?.label }}</td>
          <td>{{ item?.value }}</td>
          <td class="action-buttons">
            <button
              class="icon-centered"
              (click)="drop(i)"
              type="button"
              nglButton
              variant="text-destructive"
              iconName="utility:delete"
              iconPosition="right"
            ></button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="identifierRequired" class="invalid-feedback">This field is required</div>
  </div>
</div>
